export const benefit_options = [ //福利选项
  {
    id: 0,
    label: '保险',
    list: [
      {
        id: 0,
        leve1_id: 0,
        iconfont: 'iconhudun',
        label: '五险一金',
        desc: '缴纳养老保险、医疗保险、失业保险、工伤保险、生育保险和住房公积金'
      },
      {
        id: 1,
        leve1_id: 0,
        iconfont: 'iconxiangzi',
        label: '补充医疗保险',
        desc: '补充医疗保险、商业医疗保险、社会互助和社区医疗保险等多种形式'
      },
      {
        id: 2,
        leve1_id: 0,
        iconfont: 'iconxindiantu',
        label: '定期体检',
        desc: '阶段性职业健康检查'
      },
      {
        id: 3,
        leve1_id: 0,
        iconfont: 'iconshizhong',
        label: '加班补助',
        desc: '正常工作时间之外的工资报酬'
      }
    ]
  },
  {
    id: 1,
    label: '薪资期权',
    list: [
      {
        id: 0,
        leve1_id: 1,
        iconfont: 'iconrili',
        label: '全勤奖',
        desc: '对于全勤员工给予全勤奖'
      },
      {
        id: 1,
        leve1_id: 1,
        iconfont: 'iconjiangbei',
        label: '年终奖',
        desc: '年末给予员工年终奖励，对一年来的工作业绩给予肯定'
      },
      {
        id: 2,
        leve1_id: 1,
        iconfont: 'iconzoushi',
        label: '股票期权',
        desc: '对优秀员工提供股票期权'
      },
    ]
  },
  {
    id: 2,
    label: '度假休假',
    list: [
      {
        id: 0,
        leve1_id: 2,
        iconfont: 'iconshu',
        label: '带薪年假',
        desc: '为员工提供带薪年休假'
      },
      {
        id: 1,
        leve1_id: 2,
        iconfont: 'iconqizi',
        label: '员工旅游',
        desc: '组织员工旅游活动'
      },
    ]
  },
  {
    id: 3,
    label: '度假休假',
    list: [
      {
        id: 0,
        leve1_id: 3,
        iconfont: 'icongongjiaoche',
        label: '免费班车',
        desc: '配有班车，免费接送员工上下班'
      },
      {
        id: 1,
        leve1_id: 3,
        iconfont: 'iconmifan',
        label: '餐补',
        desc: '工作餐的额外补贴'
      },
      {
        id: 2,
        leve1_id: 3,
        iconfont: 'icondianhua1',
        label: '通讯补贴',
        desc: '补贴员工因公实际发生的公务话费'
      },
      {
        id: 3,
        leve1_id: 3,
        iconfont: 'iconchuzuche',
        label: '交通补贴',
        desc: '补贴员工因公实际发生的交通费用'
      },
      {
        id: 4,
        leve1_id: 3,
        iconfont: 'iconmianbao',
        label: '包吃',
        desc: '补贴员工因公实际发生的饮食费用'
      },
      {
        id: 5,
        leve1_id: 3,
        iconfont: 'iconfangzi',
        label: '住房补贴',
        desc: '每月员工因公实际发生的住宿费用'
      },
      {
        id: 6,
        leve1_id: 3,
        iconfont: 'iconlihe',
        label: '节日福利',
        desc: '法定或者特定节日时提供礼物'
      },
      {
        id: 7,
        leve1_id: 3,
        iconfont: 'icontiandian',
        label: '零食下午茶',
        desc: '为员工提供零食、饮料、水果作为下午茶'
      },
      {
        id: 8,
        leve1_id: 3,
        iconfont: 'iconshuben',
        label: '学习基金',
        desc: '每月固定金额学习基金，帮助员工自我提升'
      },
    ]
  }
]
export const overtime_options = [ //加班情况
  {
    value: 0,
    label: '不加班',
  },
  {
    value: 1,
    label: '偶尔加班',
  },
  {
    value: 2,
    label: '弹性工作',
  }
]
export const rest_options = [ //休息时间
  {
    value: 0,
    label: '双休',
  },
  {
    value: 1,
    label: '单休',
  },
  {
    value: 2,
    label: '大小周',
  },
  {
    value: 3,
    label: '排班轮休',
  },
]
export const phase_options = [ //融资阶段
  {
    value: '未融资',
    label: '未融资',
  },
  {
    value: '天使轮',
    label: '天使轮',
  },
  {
    value: 'A轮',
    label: 'A轮',
  },
  {
    value: 'B轮',
    label: 'B轮',
  },
  {
    value: 'C轮',
    label: 'C轮',
  },
  {
    value: 'D轮及以上',
    label: 'D轮及以上',
  },
  {
    value: '已上市',
    label: '已上市',
  },
  {
    value: '不需要融资',
    label: '不需要融资',
  },
]
export const scale_options = [ //公司规模数据
  // {
  //   value:'',
  //   label:'请选择公司规模'
  // },
  {
    value: '10人以下',
    label: '10人以下'
  }, {
    value: '10-50人',
    label: '10-50人'
  }, {
    value: '50-100人',
    label: '50-100人'
  }, {
    value: '100-500人',
    label: '100-500人'
  }, {
    value: '500人以上',
    label: '500人以上'
  }
]
export const nature_options = [ //公司类型数据
  // {
  //   value:'',
  //   label:'请选择公司类型'
  // },
  {
    value: '外企',
    label: '外企'
  }, {
    value: '国企',
    label: '国企'
  }, {
    value: '民营企业',
    label: '民营企业'
  }, {
    value: '政府/非营利组织',
    label: '政府/非营利组织'
  }
]
